export const compareVersions = (v1: string, v2: string) => {
  const v1Parts = v1.split('.');
  const v2Parts = v2.split('.');

  for (let i = 0; i < 3; i++) {
    const n1 = Number(v1Parts[i]);
    const n2 = Number(v2Parts[i]);

    if (n1 > n2) return 1;

    if (n2 > n1) return -1;

    if (!isNaN(n1) && isNaN(n2)) return 1;

    if (isNaN(n1) && !isNaN(n2)) return -1;
  }

  return 0;
};
